import { AlignmentEnum } from '@boels/models';
import { of } from 'rxjs';

export const bannerMediaMockData1 = {
  uid: 'clone_cmsitem_00190005_00081050',
  uuid: 'eyJpdGVtSWQiOiJjbG9uZV9jbXNpdGVtXzAwMTkwMDA1XzAwMDgxMDUwIiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
  typeCode: 'FullWidthBannerComponent',
  modifiedtime: '2022-04-15T13:51:37.925+02:00',
  name: 'Clone testbanner 00081061',
  container: 'false',
  imageAltText: 'alt (NL)',
  removeBottomSpacing: 'false',
  children: 'cmsitem_00044016',
  subtitle:
    'Lorem ipsum dolor sit amet. Qui quis libero et velit aspernatur et rerum voluptatem hic vero magnam 33 praesentium',
  synchronizationBlocked: 'false',
  link: {
    container: 'false',
    uid: 'cmsitem_00044016',
    external: 'false',
    name: 'Direct inschrijven',
    synchronizationBlocked: 'false',
    uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMDQ0MDE2IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
    url: 'mailto:training@boels.nl',
    linkName: 'Direct inschrijven',
    typeCode: 'CMSLinkComponent',
    target: 'true',
    parents:
      'clone_cmsitem_00190005_00081050_00081107 clone_cmsitem_00190005_00081050',
  },
  removeGradient: 'false',
  media: {
    tablet: {
      code: 'cleanair-header-001c.jpg',
      mime: 'image/jpeg',
      altText: 'cleanair-header-001.jpg',
      url: '/medias/cleanair-header-001.jpg?context=bWFzdGVyfHJvb3R8MjIwMTU2fGltYWdlL2pwZWd8aDI2L2gwZi85MTY3NDUzMTkyMjIyL2NsZWFuYWlyLWhlYWRlci0wMDEuanBnfGZjZjM3Y2M1NTk0ZGEyYWE1ZGIxMWYyNGQ1NjU0OTlmNzllMWNiYzk4OTRkYzg0Mzk1M2EzYjI4OTkzOWFjYWU',
    },
    desktop: {
      code: 'cleanair-header-001b.jpg',
      mime: 'image/jpeg',
      altText: 'cleanair-header-001.jpg',
      url: '/medias/cleanair-header-001.jpg?context=bWFzdGVyfHJvb3R8MjIwMTU2fGltYWdlL2pwZWd8aGU3L2gwZi85MTY3NDUzMTI2Njg2L2NsZWFuYWlyLWhlYWRlci0wMDEuanBnfDhlN2NhN2VlYjNhNmQ1NTIyY2IyMmE3ZjdjNzg2ZTNjNWIyYzMxNjU2ZGE5NTU4N2FjNjdkMzNmN2JjODJkMjc',
    },
    mobile: {
      code: 'cleanair-header-001d.jpg',
      mime: 'image/jpeg',
      altText: 'cleanair-header-001.jpg',
      url: '/medias/cleanair-header-001.jpg?context=bWFzdGVyfHJvb3R8MjIwMTU2fGltYWdlL2pwZWd8aDI4L2gwYy85MTY3NDUzMjU3NzU4L2NsZWFuYWlyLWhlYWRlci0wMDEuanBnfGQ1ZDA1MGQxNjhjODQ1NTFhMGYzMjg0YmQzMDAzMWYwN2ZiOGJiMDgzZWUwZGI4YjQwODQxN2ZiNGU0NjgyMzk',
    },
    widescreen: {
      code: 'cleanair-header-001.jpg',
      mime: 'image/jpeg',
      altText: 'cleanair-header-001.jpg',
      url: '/medias/cleanair-header-001.jpg?context=bWFzdGVyfHJvb3R8MjIwMTU2fGltYWdlL2pwZWd8aGU1L2gxMi85MTY3NDUzMDYxMTUwL2NsZWFuYWlyLWhlYWRlci0wMDEuanBnfDk5MjNlMWM2OGZkOGEzMGE2ZjllYThjMjM4ZThkNzc4ZjQyNmU2NDRlMDFmYTJkMDY0ZTJlY2IwYWEyZjgxN2M',
    },
  },
  title:
    'Full Width Banner Editor: Lorem ipsum dolor sit amet. Est voluptate saepe aut quas ',
  alignment: 'LEFT',
};

export const bannerMediaMockData2 = {
  uid: 'clone_cmsitem_00190005_00081050_00081107',
  uuid: 'eyJpdGVtSWQiOiJjbG9uZV9jbXNpdGVtXzAwMTkwMDA1XzAwMDgxMDUwXzAwMDgxMTA3IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
  typeCode: 'FullWidthBannerComponent',
  modifiedtime: '2022-04-15T13:51:37.923+02:00',
  name: 'Clone of Clone testbanner 00081061',
  container: 'false',
  imageAltText: 'alt (NL)',
  removeBottomSpacing: 'true',
  children: 'cmsitem_00044016',
  subtitle:
    'Lorem ipsum dolor sit amet. Qui quis libero et velit aspernatur et rerum voluptatem hic vero magnam 33 praesentium',
  synchronizationBlocked: 'false',
  link: {
    container: 'false',
    uid: 'cmsitem_00044016',
    external: 'false',
    name: 'Direct inschrijven',
    synchronizationBlocked: 'false',
    uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMDQ0MDE2IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
    url: 'mailto:training@boels.nl',
    linkName: 'Direct inschrijven',
    typeCode: 'CMSLinkComponent',
    target: 'true',
    parents:
      'clone_cmsitem_00190005_00081050_00081107 clone_cmsitem_00190005_00081050',
  },
  removeGradient: 'false',
  media: {
    tablet: {
      code: 'clone00081054',
      mime: 'image/jpeg',
      altText: 'placeholder-header-tab.jpg',
      url: '/medias/placeholder-header-tab.jpg?context=bWFzdGVyfHJvb3R8NTE3MzZ8aW1hZ2UvanBlZ3xoYzAvaDEwLzg4MDc2OTUzODQ2MDYvcGxhY2Vob2xkZXItaGVhZGVyLXRhYi5qcGd8ZTkwNDFlZDY0YmNhZjU1Y2NlOWNlNzA1ODdkMmI2ODVmZTZiMTA0NTc1NGZiMjI1NWQyODMwNWVkYmI5ZTc0NA',
    },
    desktop: {
      code: 'clone00081053',
      mime: 'image/jpeg',
      altText: 'placeholder-header.jpg',
      url: '/medias/placeholder-header.jpg?context=bWFzdGVyfHJvb3R8Mzc5NzR8aW1hZ2UvanBlZ3xoODEvaDExLzg4MDc2OTUzMTkwNzAvcGxhY2Vob2xkZXItaGVhZGVyLmpwZ3w1ODUxZjNkMzIxYWM1OTJjYTVlYjljZTM0MjlhZmYyZDYyM2MyNTRjZGI1NTJkMDA3MTUzZjQ2ZTMyMTUzZTA2',
    },
    mobile: {
      code: 'clone00081055',
      mime: 'image/jpeg',
      altText: 'placeholder-header-mob.jpg',
      url: '/medias/placeholder-header-mob.jpg?context=bWFzdGVyfHJvb3R8NTY5NDJ8aW1hZ2UvanBlZ3xoYWUvaDBkLzg4MDc2OTU0NTAxNDIvcGxhY2Vob2xkZXItaGVhZGVyLW1vYi5qcGd8YjkzNTAwMTVjZDQ0ZWE0MGU3YjM1NDY4OGQzOGVmMzg5ZDU2YTVkMmRjMjcyNzJkOGEyZjU5ZTViZDE4ODA3Zg',
    },
    widescreen: {
      code: 'clone00081052',
      mime: 'image/jpeg',
      altText: 'placeholder-header.jpg',
      url: '/medias/placeholder-header.jpg?context=bWFzdGVyfHJvb3R8Mzc5NzR8aW1hZ2UvanBlZ3xoN2YvaDE0Lzg4MDc2OTUyNTM1MzQvcGxhY2Vob2xkZXItaGVhZGVyLmpwZ3w4YjVmNWViYmMyMWFjMzFjM2Q3Y2E0OTM1NDliZjI3YTdlZTFjYzk0YTQxMDJiYTE1YTI3ZTk4Y2JmMmZlODdh',
    },
  },
  title:
    'Full Width Banner Editor: Lorem ipsum dolor sit amet. Est voluptate saepe aut quas ',
  alignment: 'CENTER',
};

export const bannerMediaMockDataQACenter = {
  data$: of({
    uid: 'cmsitem_00193005',
    uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMTkzMDA1IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
    typeCode: 'FullWidthBannerComponent',
    modifiedtime: '2022-11-15T14:05:47.699+01:00',
    name: 'Full Width ',
    container: false,
    removeBottomSpacing: true,
    children: 'cmsitem_00024040',
    subtitle:
      'With Onsite Rental, we provide a temporary rental point at your location. You can compare it to a shop. A basic package of equipment is available right away to you and your employees there.',
    synchronizationBlocked: false,
    link: {
      container: false,
      uid: 'cmsitem_00024040',
      external: false,
      name: 'Alles over veilig werken - Link',
      synchronizationBlocked: false,
      uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMDI0MDQwIiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
      url: '/working-safely',
      linkName: 'All about working safely',
      typeCode: 'CMSLinkComponent',
      parents: 'cmsitem_00193005',
      target: false,
    },
    removeGradient: true,
    media: {
      tablet: {
        code: 'clone_00056165',
        mime: 'image/jpeg',
        altText: 'Industrie bedrijventerrein',
        url: '/medias/cleanair-header-001.jpg?context=bWFzdGVyfHJvb3R8MjIwMTU2fGltYWdlL2pwZWd8aGU3L2gwZi85MTY3NDUzMTI2Njg2L2NsZWFuYWlyLWhlYWRlci0wMDEuanBnfDhlN2NhN2VlYjNhNmQ1NTIyY2IyMmE3ZjdjNzg2ZTNjNWIyYzMxNjU2ZGE5NTU4N2FjNjdkMzNmN2JjODJkMjc',
      },
      desktop: {
        code: 'clone_00056164',
        mime: 'image/jpeg',
        altText: 'Industrie bedrijventerrein',
        url: '/medias/industrie-header.jpg?context=bWFzdGVyfHJvb3R8OTMxNzMxfGltYWdlL2pwZWd8aGNlL2g1Mi84ODE5OTE2NDcyMzUwL2luZHVzdHJpZS1oZWFkZXIuanBnfDBkNzc4MTJmN2EzNWFjMWNjM2ZkZjcyZTM4Njk4NWVkNTA2ZTc5MzgzYTQ5MzMyZTk1YjRkODQwMWU4MzAwZmU',
      },
      mobile: {
        code: 'clone_00056166',
        mime: 'image/jpeg',
        altText: 'Industrie bedrijventerrein',
        url: '/medias/industrie-header-mob.jpg?context=bWFzdGVyfHJvb3R8NDIyMDIwfGltYWdlL2pwZWd8aGRkL2g1OC84ODE5OTE2NjAzNDIyL2luZHVzdHJpZS1oZWFkZXItbW9iLmpwZ3w4MjZhZGMwZGY1ZGRlYjgwOWFjNjU3OWY3YTVjZTJkZmUzNWEyNmMyNjBkMjgyNjc1MzEzMWQ0YTUxYzQyODM2',
      },
      widescreen: {
        code: 'clone_00056163',
        mime: 'image/jpeg',
        altText: 'Industrie bedrijventerrein',
        url: '/medias/industrie-header.jpg?context=bWFzdGVyfHJvb3R8OTMxNzMxfGltYWdlL2pwZWd8aDBkL2g1Mi84ODE5OTE2NDA2ODE0L2luZHVzdHJpZS1oZWFkZXIuanBnfGU3OTkyZjI0OTEwODVjZTVlNmM4ZjA5OTc5MTk2ODAwMGRhYzRkNjc1NTI0YTllYzU4N2Q5YzVlZDVkMDkxMDU',
      },
    },
    title: 'No bottom, no gradient',
    alignment: AlignmentEnum.CENTER,
  }),
};

export const bannerMediaMockDataQALeft = {
  data$: of({
    uid: 'cmsitem_00193005',
    uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMTkzMDA1IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
    typeCode: 'FullWidthBannerComponent',
    modifiedtime: '2022-11-15T14:05:47.699+01:00',
    name: 'Full Width ',
    container: false,
    removeBottomSpacing: true,
    children: 'cmsitem_00024040',
    subtitle:
      'With Onsite Rental, we provide a temporary rental point at your location. You can compare it to a shop. A basic package of equipment is available right away to you and your employees there.',
    synchronizationBlocked: false,
    link: {
      container: false,
      uid: 'cmsitem_00024040',
      external: false,
      name: 'Alles over veilig werken - Link',
      synchronizationBlocked: false,
      uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMDI0MDQwIiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
      url: '/working-safely',
      linkName: 'All about working safely',
      typeCode: 'CMSLinkComponent',
      parents: 'cmsitem_00193005',
      target: false,
    },
    removeGradient: true,
    media: {
      tablet: {
        code: 'clone_00056165',
        mime: 'image/jpeg',
        altText: 'Industrie bedrijventerrein',
        url: '/medias/cleanair-header-001.jpg?context=bWFzdGVyfHJvb3R8MjIwMTU2fGltYWdlL2pwZWd8aGU3L2gwZi85MTY3NDUzMTI2Njg2L2NsZWFuYWlyLWhlYWRlci0wMDEuanBnfDhlN2NhN2VlYjNhNmQ1NTIyY2IyMmE3ZjdjNzg2ZTNjNWIyYzMxNjU2ZGE5NTU4N2FjNjdkMzNmN2JjODJkMjc',
      },
      desktop: {
        code: 'clone_00056164',
        mime: 'image/jpeg',
        altText: 'Industrie bedrijventerrein',
        url: '/medias/industrie-header.jpg?context=bWFzdGVyfHJvb3R8OTMxNzMxfGltYWdlL2pwZWd8aGNlL2g1Mi84ODE5OTE2NDcyMzUwL2luZHVzdHJpZS1oZWFkZXIuanBnfDBkNzc4MTJmN2EzNWFjMWNjM2ZkZjcyZTM4Njk4NWVkNTA2ZTc5MzgzYTQ5MzMyZTk1YjRkODQwMWU4MzAwZmU',
      },
      mobile: {
        code: 'clone_00056166',
        mime: 'image/jpeg',
        altText: 'Industrie bedrijventerrein',
        url: '/medias/industrie-header-mob.jpg?context=bWFzdGVyfHJvb3R8NDIyMDIwfGltYWdlL2pwZWd8aGRkL2g1OC84ODE5OTE2NjAzNDIyL2luZHVzdHJpZS1oZWFkZXItbW9iLmpwZ3w4MjZhZGMwZGY1ZGRlYjgwOWFjNjU3OWY3YTVjZTJkZmUzNWEyNmMyNjBkMjgyNjc1MzEzMWQ0YTUxYzQyODM2',
      },
      widescreen: {
        code: 'clone_00056163',
        mime: 'image/jpeg',
        altText: 'Industrie bedrijventerrein',
        url: '/medias/industrie-header.jpg?context=bWFzdGVyfHJvb3R8OTMxNzMxfGltYWdlL2pwZWd8aDBkL2g1Mi84ODE5OTE2NDA2ODE0L2luZHVzdHJpZS1oZWFkZXIuanBnfGU3OTkyZjI0OTEwODVjZTVlNmM4ZjA5OTc5MTk2ODAwMGRhYzRkNjc1NTI0YTllYzU4N2Q5YzVlZDVkMDkxMDU',
      },
    },
    title: 'No bottom, no gradient',
    alignment: AlignmentEnum.LEFT,
  }),
};

export const bannerMediaMockDataQARight = {
  data$: of({
    uid: 'cmsitem_00193005',
    uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMTkzMDA1IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
    typeCode: 'FullWidthBannerComponent',
    modifiedtime: '2022-11-15T14:05:47.699+01:00',
    name: 'Full Width ',
    container: false,
    removeBottomSpacing: true,
    children: 'cmsitem_00024040',
    subtitle:
      'With Onsite Rental, we provide a temporary rental point at your location. You can compare it to a shop. A basic package of equipment is available right away to you and your employees there.',
    synchronizationBlocked: false,
    link: {
      container: false,
      uid: 'cmsitem_00024040',
      external: false,
      name: 'Alles over veilig werken - Link',
      synchronizationBlocked: false,
      uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMDI0MDQwIiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
      url: '/working-safely',
      linkName: 'All about working safely',
      typeCode: 'CMSLinkComponent',
      parents: 'cmsitem_00193005',
      target: false,
    },
    removeGradient: false,
    media: {
      tablet: {
        code: 'clone_00056165',
        mime: 'image/jpeg',
        altText: 'Industrie bedrijventerrein',
        url: '/medias/cleanair-header-001.jpg?context=bWFzdGVyfHJvb3R8MjIwMTU2fGltYWdlL2pwZWd8aGU3L2gwZi85MTY3NDUzMTI2Njg2L2NsZWFuYWlyLWhlYWRlci0wMDEuanBnfDhlN2NhN2VlYjNhNmQ1NTIyY2IyMmE3ZjdjNzg2ZTNjNWIyYzMxNjU2ZGE5NTU4N2FjNjdkMzNmN2JjODJkMjc',
      },
      desktop: {
        code: 'clone_00056164',
        mime: 'image/jpeg',
        altText: 'Industrie bedrijventerrein',
        url: '/medias/industrie-header.jpg?context=bWFzdGVyfHJvb3R8OTMxNzMxfGltYWdlL2pwZWd8aGNlL2g1Mi84ODE5OTE2NDcyMzUwL2luZHVzdHJpZS1oZWFkZXIuanBnfDBkNzc4MTJmN2EzNWFjMWNjM2ZkZjcyZTM4Njk4NWVkNTA2ZTc5MzgzYTQ5MzMyZTk1YjRkODQwMWU4MzAwZmU',
      },
      mobile: {
        code: 'clone_00056166',
        mime: 'image/jpeg',
        altText: 'Industrie bedrijventerrein',
        url: '/medias/industrie-header-mob.jpg?context=bWFzdGVyfHJvb3R8NDIyMDIwfGltYWdlL2pwZWd8aGRkL2g1OC84ODE5OTE2NjAzNDIyL2luZHVzdHJpZS1oZWFkZXItbW9iLmpwZ3w4MjZhZGMwZGY1ZGRlYjgwOWFjNjU3OWY3YTVjZTJkZmUzNWEyNmMyNjBkMjgyNjc1MzEzMWQ0YTUxYzQyODM2',
      },
      widescreen: {
        code: 'clone_00056163',
        mime: 'image/jpeg',
        altText: 'Industrie bedrijventerrein',
        url: '/medias/industrie-header.jpg?context=bWFzdGVyfHJvb3R8OTMxNzMxfGltYWdlL2pwZWd8aDBkL2g1Mi84ODE5OTE2NDA2ODE0L2luZHVzdHJpZS1oZWFkZXIuanBnfGU3OTkyZjI0OTEwODVjZTVlNmM4ZjA5OTc5MTk2ODAwMGRhYzRkNjc1NTI0YTllYzU4N2Q5YzVlZDVkMDkxMDU',
      },
    },
    title: 'No bottom, with gradient',
    alignment: AlignmentEnum.RIGHT,
  }),
};
